const union = (first, second) => {
  return first.concat(
    second.filter((key) => first.indexOf(key) == -1)
  )
}

module.exports = union



// WEBPACK FOOTER //
// ../node_modules/berries/lib/union.js